import React from 'react';
import { Link } from 'react-router-dom';
import { BaseProps } from '@make-software/cspr-design';
import styled from 'styled-components';
import { useRouteMatchPath } from '../../router/utils';

interface HistoryLinkProps extends BaseProps {
  href: string;
  ariaDescription?: string;
}

const StyledWrapper = styled.span(({ theme }) => ({
  color: theme.styleguideColors.contentBlue,
  '& > *': {
    color: theme.styleguideColors.contentBlue,
  },
  '&:hover > *': {
    color: theme.styleguideColors.fillPrimaryRed,
  },
  '&:active > *': {
    color: theme.styleguideColors.fillPrimaryRedClick,
  },
}));

const StyledLink = styled(Link)(() => ({
  alignItems: 'center',
  boxSizing: 'border-box',
  minHeight: 24,
}));

export const HistoryLink = ({
  href,
  ariaDescription,
  children,
}: HistoryLinkProps) => {
  const match = useRouteMatchPath();

  return (
    <StyledWrapper>
      <StyledLink
        to={href}
        state={{
          prevRouteMatch: match,
          allowedGoBack: true,
        }}
        aria-description={ariaDescription}
      >
        {children}
      </StyledLink>
    </StyledWrapper>
  );
};
